module.exports = __webpack_public_path__ + "static/media/student-manage.313c46ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/student-manage.png
// module id = 324
// module chunks = 6